'use client'
import React from 'react'
import { Block_Location_Map } from '@/src/generated/graphql'
import styles from './LocationMapBlock.module.scss'
import AGLocationsMap from '@/src/components/common/AGLocationsMap'
import PageGutter from '@/src/components/common/PageGutter'

function LocationMapBlockClient(_: Block_Location_Map) {
  return (
    <div className={styles.container}>
      <PageGutter className={styles.gutterContent}>
        <div className={styles.headingsContainer}>
          <h3 className={styles.heading}>{_.heading}</h3>
          <div className={styles.subheading}>{_.subheading}</div>
        </div>
        <AGLocationsMap />
      </PageGutter>
    </div>
  )
}

export default React.memo(LocationMapBlockClient)
